import { z } from 'zod';
import { DecimalLikeSchema, IsoDateTimeSchema, PaginationSchema, UuidSchema } from './common.js';
import { DescuentoParceladoRequestSchema, DescuentoParceladoViewSchema } from './planilla.js';
export const InventarioSchema = z.object({
    id: UuidSchema,
    nombre: z.string().min(1).max(200),
    codigo: z.string().min(1).max(100),
    categoria: z.string().max(100).nullable(),
    cantidad: z.number().int().nullable(),
    stockMinimo: z.number().int().nullable(),
    estado: z.string().max(50).nullable(),
    costoUnitario: DecimalLikeSchema.nullable(),
    sucursalId: UuidSchema.nullable(),
    imagenUrl: z.string().max(1000).nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
const inventarioMutable = {
    categoria: z.string().max(100).nullable().optional(),
    cantidad: z.number().int().nullable().optional(),
    stockMinimo: z.number().int().nullable().optional(),
    estado: z.string().max(50).nullable().optional(),
    costoUnitario: DecimalLikeSchema.nullable().optional(),
    sucursalId: UuidSchema.nullable().optional(),
    imagenUrl: z.string().max(1000).nullable().optional(),
};
export const CreateInventarioRequestSchema = z.object({
    nombre: z.string().min(1).max(200),
    codigo: z.string().min(1).max(100),
    ...inventarioMutable,
});
export const UpdateInventarioRequestSchema = z.object({
    nombre: z.string().min(1).max(200).optional(),
    codigo: z.string().min(1).max(100).optional(),
    ...inventarioMutable,
});
export const InventarioListQuerySchema = PaginationSchema.extend({
    categoria: z.string().max(100).optional(),
    sucursalId: UuidSchema.optional(),
});
export const InventarioAsignacionSchema = z.object({
    id: UuidSchema,
    guardiaId: UuidSchema,
    inventarioId: UuidSchema,
    cantidad: z.number().int().nullable(),
    fechaAsignacion: IsoDateTimeSchema.nullable(),
    fechaDevolucion: IsoDateTimeSchema.nullable(),
    condicionDevuelta: z.enum(['nuevo', 'usado']).nullable(),
    stockDescontado: z.boolean(),
    sucursalId: UuidSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
    // A-9: listado resolve guardia e ítem (a tabela não mostrava quem recebeu o quê).
    guardia: z.object({ nombre: z.string() }).nullable().optional(),
    inventario: z.object({ nombre: z.string(), codigo: z.string().nullable() }).nullable().optional(),
});
export const CreateInventarioAsignacionRequestSchema = z.object({
    guardiaId: UuidSchema,
    inventarioId: UuidSchema,
    cantidad: z.number().int().nullable().optional(),
    fechaAsignacion: IsoDateTimeSchema.optional(),
    fechaDevolucion: IsoDateTimeSchema.nullable().optional(),
    sucursalId: UuidSchema.nullable().optional(),
});
export const DevolverInventarioAsignacionRequestSchema = z.object({
    fechaDevolucion: IsoDateTimeSchema.optional(),
    // Condição com que o item reentra no estoque. Default 'usado' no service
    // (item devolvido já foi usado). Opcional no request.
    condicion: z.enum(['nuevo', 'usado']).optional(),
});
export const InventarioAsignacionListQuerySchema = PaginationSchema.extend({
    guardiaId: UuidSchema.optional(),
    inventarioId: UuidSchema.optional(),
});
export const InventarioSummarySchema = z.object({
    stockTotal: z.number().int(),
    criticos: z.number().int(),
});
export const CreateAsignacionConDescuentoRequestSchema = z.object({
    asignacion: CreateInventarioAsignacionRequestSchema,
    descuento: DescuentoParceladoRequestSchema.omit({ guardiaId: true, origenInventarioId: true }),
});
export const AsignacionConDescuentoResponseSchema = z.object({
    asignacion: InventarioAsignacionSchema,
    descuento: DescuentoParceladoViewSchema,
});
//# sourceMappingURL=inventario.js.map